import FormSequenceControl from './FormSequenceControl';

export default {
  mixins: [
    FormSequenceControl,
  ],
  methods: {
    copyField(campoBase, listaCampos) {
      console.log("copyField");
      console.log("campoBase:", campoBase);
      let campoNovo = {
        ativo: campoBase.ativo,
        searchKey: false,
        sequenciaExibicao: this.getNextSequenceNumber(listaCampos),
        obrigatorio: campoBase.obrigatorio,
        tipo: campoBase.tipo,
        nome: campoBase.nome,
        defaultValue: campoBase.defaultValue,
        dica: campoBase.dica,
        isMandatoryAttachment: campoBase.isMandatoryAttachment,
        geraAnomalia: campoBase.geraAnomalia,
        scriptPythonAfterProcess: campoBase.scriptPythonAfterProcess,
        scriptPythonValidation: campoBase.scriptPythonValidation,
        scriptPythonProcess: campoBase.scriptPythonProcess,
        permiteAnexo: campoBase.permiteAnexo,
        pendencyGenerationNotify: campoBase.pendencyGenerationNotify,
        pendencyPriority: campoBase.pendencyPriority,
        profilePendencyId: campoBase.profilePendencyId,
        profilesApprover: campoBase.profilesApprover,
        profilesViewer: campoBase.profilesViewer,
        postCalculationScript: campoBase.postCalculationScript,
        pendencyUniqueOpened: campoBase.pendencyUniqueOpened,
        attachmentMobileMode: campoBase.attachmentMobileMode,
        valores: [],
        tipAttachments: [],
        subForm:  {
          title: campoBase.subForm.title,
          active: campoBase.subForm.active,
          fields: [],
        },
        predefinedScriptCalculate: campoBase.predefinedScriptCalculate,
        predefinedScriptProcess: campoBase.predefinedScriptProcess,
        predefinedScriptAfterProcess: campoBase.predefinedScriptAfterProcess,
        predefinedScriptValidation: campoBase.predefinedScriptValidation,
      };

      listaCampos.push(campoNovo);


      // this.getSortedList(campoBase.subForm).forEach(subform => {
      //   this.copySubForm(subform, campoNovo.subForm.fields);
      // });
      this.getSortedList(campoBase.subForm.fields).forEach(campoTemp => {
        this.copyField(campoTemp, campoNovo.subForm.fields)
      })

      this.getSortedList(campoBase.valores).forEach(valorTemp => {
        this.copyValue(valorTemp, campoNovo.valores);
      });
    },
    copyValue(valorBase, listaValores) {
      let valorNovo = {
        ativo: valorBase.ativo,
        sequenciaExibicao: this.getNextSequenceNumber(listaValores),
        valor: valorBase.valor,
        geraAnomalia: valorBase.geraAnomalia,
        possuiCamposAdicionais: valorBase.possuiCamposAdicionais,
        pendencyGenerationNotify: valorBase.pendencyGenerationNotify,
        pendencyPriority: valorBase.pendencyPriority,
        profilePendencyId: valorBase.profilePendencyId,
        profilesApprover: valorBase.profilesApprover,
        profilesViewer: valorBase.profilesViewer,
        camposAdicionais: [],
      };

      listaValores.push(valorNovo);

      this.getSortedList(valorBase.camposAdicionais).forEach(campoAddTemp => {
        this.copyField(campoAddTemp, valorNovo.camposAdicionais);
      });
    },
    getNextSequenceNumber(items) {
      let sequence = 0;
      for (let item of items) {
        if (item.ativo == true) {
          if (item.sequenciaExibicao > sequence) {
            sequence = item.sequenciaExibicao;
          }
        }
      }
      return sequence + 1;
    },
  }
}

